<h1 class="text-xl text-secondary font-bold text-center border-b pt-1 pb-2">
  <ng-content select="[dialog-title]"></ng-content>
</h1>
<div class="flex flex-col h-full">
  <ng-content></ng-content>
</div>
<div class="border-t">
  <ng-content select="[dialog-actions]"></ng-content>
</div>